// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountSettingsArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';
import type {
  Exact,
  OpenapiAccountAtlasSettingsRefileScenarioEnum,
  OpenapiAccountTreasurySettingsPartnerEnum,
  OpenapiAccountTreasurySettingsAdditionalPartnersEnum,
} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {stripeAccountPayoutSettingsFragment} from './stripeAccountPayoutSettingsFragment';
import {stripeAccountTermsOfServiceFragment} from './stripeAccountTermsOfServiceFragment';

import type {StripeAccountPayoutSettingsFragmentData} from './stripeAccountPayoutSettingsFragment';
import type {StripeAccountTermsOfServiceFragmentData} from './stripeAccountTermsOfServiceFragment';

const doc = gql`
  fragment StripeAccountSettingsArkFragment on OpenapiAccountSettings {
    atlas {
      tos_acceptance {
        date
      }
      refile_scenario
      can_skip_external_account
      has_incorporated_and_received_ein
      has_submitted_atlas_application
    }
    dashboard {
      display_name
      timezone
    }
    payouts {
      ...StripeAccountPayoutSettingsFragment
    }
    payments {
      statement_descriptor
      statement_descriptor_kana
      statement_descriptor_kanji
      statement_descriptor_prefix
      statement_descriptor_prefix_kana
      statement_descriptor_prefix_kanji
    }
    card_payments {
      decline_on {
        avs_failure
        cvc_failure
      }
      statement_descriptor_prefix
      statement_descriptor_prefix_kana
      statement_descriptor_prefix_kanji
    }
    bacs_debit_payments {
      ... on OpenapiAccountBacsDebitPaymentsSettings {
        display_name
      }
    }
    branding {
      show_support_phone
      icon {
        id
      }
      logo {
        id
      }
      primary_color
    }
    treasury {
      partner
      additional_partners
      tos_acceptance {
        ...StripeAccountTermsOfServiceFragment
      }
    }
    card_issuing {
      tos_acceptance {
        ip
        date
      }
      tos_acceptances {
        account_holder {
          ip
          date
          url
        }
        apple_pay_celtic {
          ip
          date
          url
        }
        apple_pay_cross_river {
          ip
          date
          url
        }
        spend_card_celtic {
          ip
          date
          url
        }
        spend_card_cross_river {
          ip
          date
          url
        }
        charge_card_celtic {
          ip
          date
          url
        }
        charge_card_cross_river {
          ip
          date
          url
        }
      }
    }
    card_issuing_payout {
      tos_acceptance {
        ip
        date
      }
    }
    crypto_payments {
      tos_acceptances {
        ip
        date
        user_agent
      }
    }
    crypto_transfers {
      tos_acceptances {
        zero_hash_recipient {
          ip
          date
          url
        }
        zero_hash_platform {
          ip
          date
          url
        }
      }
    }
    tax_forms {
      consented_to_paperless_delivery
    }
  }

  ${stripeAccountPayoutSettingsFragment}
  ${stripeAccountTermsOfServiceFragment}
`;

export const stripeAccountSettingsArkFragment: StripeAccountSettingsArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountSettingsArkFragmentData = {
  readonly __typename: 'OpenapiAccountSettings';
  readonly atlas: {
    readonly __typename: 'OpenapiAccountAtlasSettings';
    readonly refile_scenario: OpenapiAccountAtlasSettingsRefileScenarioEnum;
    readonly can_skip_external_account: boolean | null;
    readonly has_incorporated_and_received_ein: boolean | null;
    readonly has_submitted_atlas_application: boolean | null;
    readonly tos_acceptance: {
      readonly __typename: 'OpenapiAtlasAccountTermsOfService';
      readonly date: number | null;
    } | null;
  } | null;
  readonly dashboard: {
    readonly __typename: 'OpenapiAccountDashboardSettings';
    readonly display_name: string | null;
    readonly timezone: string | null;
  };
  readonly payouts: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountPayoutSettings'},
    [StripeAccountPayoutSettingsFragmentData]
  > | null;
  readonly payments: {
    readonly __typename: 'OpenapiAccountPaymentsSettings';
    readonly statement_descriptor: string | null;
    readonly statement_descriptor_kana: string | null;
    readonly statement_descriptor_kanji: string | null;
    readonly statement_descriptor_prefix: string | null;
    readonly statement_descriptor_prefix_kana: string | null;
    readonly statement_descriptor_prefix_kanji: string | null;
  };
  readonly card_payments: {
    readonly __typename: 'OpenapiAccountCardPaymentsSettings';
    readonly statement_descriptor_prefix: string | null;
    readonly statement_descriptor_prefix_kana: string | null;
    readonly statement_descriptor_prefix_kanji: string | null;
    readonly decline_on: {
      readonly __typename: 'OpenapiAccountDeclineChargeOn';
      readonly avs_failure: boolean;
      readonly cvc_failure: boolean;
    } | null;
  };
  readonly bacs_debit_payments: {
    readonly __typename: 'OpenapiAccountBacsDebitPaymentsSettings';
    readonly display_name: string | null;
  } | null;
  readonly branding: {
    readonly __typename: 'OpenapiAccountBrandingSettings';
    readonly show_support_phone: boolean | null;
    readonly primary_color: string | null;
    readonly icon: {
      readonly __typename: 'OpenapiFile';
      readonly id: string;
    } | null;
    readonly logo: {
      readonly __typename: 'OpenapiFile';
      readonly id: string;
    } | null;
  };
  readonly treasury: {
    readonly __typename: 'OpenapiAccountTreasurySettings';
    readonly partner: OpenapiAccountTreasurySettingsPartnerEnum | null;
    readonly additional_partners: ReadonlyArray<OpenapiAccountTreasurySettingsAdditionalPartnersEnum> | null;
    readonly tos_acceptance: GraphQlFragmentUnion<
      {readonly __typename: 'OpenapiAccountTermsOfService'},
      [StripeAccountTermsOfServiceFragmentData]
    > | null;
  } | null;
  readonly card_issuing: {
    readonly __typename: 'OpenapiAccountCardIssuingSettings';
    readonly tos_acceptance: {
      readonly __typename: 'OpenapiCardIssuingAccountTermsOfService';
      readonly ip: string | null;
      readonly date: number | null;
    } | null;
    readonly tos_acceptances: {
      readonly __typename: 'OpenapiCardIssuingAccountTermsOfServiceAcceptances';
      readonly account_holder: {
        readonly __typename: 'OpenapiCardIssuingAccountGranularTermsOfServiceAcceptance';
        readonly ip: string | null;
        readonly date: number | null;
        readonly url: string | null;
      } | null;
      readonly apple_pay_celtic: {
        readonly __typename: 'OpenapiCardIssuingAccountGranularTermsOfServiceAcceptance';
        readonly ip: string | null;
        readonly date: number | null;
        readonly url: string | null;
      } | null;
      readonly apple_pay_cross_river: {
        readonly __typename: 'OpenapiCardIssuingAccountGranularTermsOfServiceAcceptance';
        readonly ip: string | null;
        readonly date: number | null;
        readonly url: string | null;
      } | null;
      readonly spend_card_celtic: {
        readonly __typename: 'OpenapiCardIssuingAccountGranularTermsOfServiceAcceptance';
        readonly ip: string | null;
        readonly date: number | null;
        readonly url: string | null;
      } | null;
      readonly spend_card_cross_river: {
        readonly __typename: 'OpenapiCardIssuingAccountGranularTermsOfServiceAcceptance';
        readonly ip: string | null;
        readonly date: number | null;
        readonly url: string | null;
      } | null;
      readonly charge_card_celtic: {
        readonly __typename: 'OpenapiCardIssuingAccountGranularTermsOfServiceAcceptance';
        readonly ip: string | null;
        readonly date: number | null;
        readonly url: string | null;
      } | null;
      readonly charge_card_cross_river: {
        readonly __typename: 'OpenapiCardIssuingAccountGranularTermsOfServiceAcceptance';
        readonly ip: string | null;
        readonly date: number | null;
        readonly url: string | null;
      } | null;
    } | null;
  } | null;
  readonly card_issuing_payout: {
    readonly __typename: 'OpenapiAccountCardIssuingPayoutSettings';
    readonly tos_acceptance: {
      readonly __typename: 'OpenapiCardIssuingAccountTermsOfService';
      readonly ip: string | null;
      readonly date: number | null;
    } | null;
  } | null;
  readonly crypto_payments: {
    readonly __typename: 'OpenapiAccountCryptoPaymentsSettings';
    readonly tos_acceptances: {
      readonly __typename: 'OpenapiCryptoPaymentsAccountTermsOfServiceAcceptances';
      readonly ip: string | null;
      readonly date: number | null;
      readonly user_agent: string | null;
    } | null;
  } | null;
  readonly crypto_transfers: {
    readonly __typename: 'OpenapiAccountCryptoTransfersSettings';
    readonly tos_acceptances: {
      readonly __typename: 'OpenapiCryptoTransfersAccountTermsOfServiceAcceptances';
      readonly zero_hash_recipient: {
        readonly __typename: 'OpenapiCryptoTransfersAccountTermsOfServiceAcceptanceDetails';
        readonly ip: string | null;
        readonly date: number | null;
        readonly url: string | null;
      } | null;
      readonly zero_hash_platform: {
        readonly __typename: 'OpenapiCryptoTransfersAccountTermsOfServiceAcceptanceDetails';
        readonly ip: string | null;
        readonly date: number | null;
        readonly url: string | null;
      } | null;
    } | null;
  } | null;
  readonly tax_forms: {
    readonly __typename: 'OpenapiTaxReportingAccountSettingsResourceTaxFormSettings';
    readonly consented_to_paperless_delivery: boolean;
  } | null;
};

export type StripeAccountSettingsArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountSettingsArkFragmentPermissions = {
  ...stripeAccountPayoutSettingsFragment.permissions,
  ...stripeAccountTermsOfServiceFragment.permissions,
} as const;

doc.permissions = stripeAccountSettingsArkFragmentPermissions;

export type StripeAccountSettingsArkFragmentPermissions = V1PermissionToken<
  typeof stripeAccountSettingsArkFragmentPermissions
>;

export type StripeAccountSettingsArkFragmentDocument = GraphQlDocument<
  StripeAccountSettingsArkFragmentData,
  StripeAccountSettingsArkFragmentVariables,
  StripeAccountSettingsArkFragmentPermissions
>;
